<!-- .block-products-carousel -->
<div
    class="block-products-carousel"
    [ngClass]="{
        'block-products-carousel--loading': blockProductCarouselService.loading,
        'block-products-carousel--has-items': !!columns?.length
    }"
    [attr.data-layout]="'grid-'"
>
    <div>
        <app-block-header [tag]="translateHelper.localize(tag)" [name]="translateHelper.localize(name)" [headers]="headers" [arrows]="true" (next)="carousel.next()" (prev)="carousel.prev()" [icon]="icon"></app-block-header>

        <div class="block-products-carousel__slider">
            <div class="block-products-carousel__preloader"></div>

            <owl-carousel-o class="owl-slider-item" [options]="carouselOptions" appOwlPreventClick #carousel>
                <ng-template *ngFor="let product of products[blockProductCarouselService.selectedHeaderValue]?.products; let odd =odd;" carouselSlide>
                        <div  class="block-products-carousel__cell">
                            <app-realestate-card *ngIf="mode == 'property'" [product]="product" [bgColor]="odd % 2?'#889194':'#a58081'" style="width: 100%;"></app-realestate-card>
                            <app-product-card-new *ngIf="mode == 'product'" [product]="product" layout="card-3" style="width: 100%;"></app-product-card-new>
                        </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- .block-products-carousel / end -->
